import { createCoursePass, createSportPass, createAuxiliarPass } from './createPass'
import { listCoursePasses, listSportPasses, listAuxiliarPasses } from './listPasses'
import { updateStatusPass } from './updateStatusPass'
import { statusBiometricPass } from './statusBiometricPass'
import { processBiometricPass } from './processBiometricPass'
import { revokeBiometricPass } from './revokeBiometricPass'
import { getPricePasses } from './getPricePasses'

export default {
  listCoursePasses: listCoursePasses,
  listSportPasses: listSportPasses,
  listAuxiliarPasses: listAuxiliarPasses,
  createCoursePass: createCoursePass,
  createSportPass: createSportPass,
  createAuxiliarPass: createAuxiliarPass,
  updateStatus: updateStatusPass,
  statusBiometric: statusBiometricPass,
  processBiometric: processBiometricPass,
  revokeBiometric: revokeBiometricPass,
  getPrices: getPricePasses
}
